<div class="video_container" [ngClass]="{
    'video_container--centered': !!isUser && !full && !minimized,
    'video_container--portrait': isPortrait,
    'video_container--minimized': !!minimized,
    'video_container--full': !!full
   }">
  @if (!isWaiting && !isEnding && !isUser) {
    <div class="video_panel">
      @if (!minimized) {
        <span (click)="onFullToggle()" class="stream_full-icon">
          @if (!full) {
            <i
              class="fas fa-expand-arrows-alt"
              matTooltip="{{ 'fullScreen' | translate | titlecase }}">
            </i>
          } @else {
            <i class="fas fa-compress-arrows-alt" matTooltip="{{ 'exitFullScreen' | translate | titlecase }}"></i>
          }
        </span>
      }
      @if (!full) {
        <span (click)="onMinimizeToggle()">
          @if (!minimized) {
            <i
              class="far fa-window-minimize"
              matTooltip="{{ 'minimize' | translate | titlecase }}">
            </i>
          } @else {
            <i class="far fa-window-maximize" matTooltip="{{ 'maximize' | translate | titlecase }}"></i>
          }
        </span>
      }
    </div>
  }

  <div
    [hidden]="!hasDevice || minimized || isVideoBlocked"
    id="video_local"
    class="video_local">
  </div>

  @if (hasDevice && !minimized) {
    <div class="video_device-message-container">
      @if (isVideoBlocked) {
        <span>
          {{'deviceBlockedVideo' | translate}}
        </span>
      }
      @if (isAudioBlocked) {
        <span>
          {{'deviceBlockedAudio' | translate}}
        </span>
      }
      @if (isConnectionFail) {
        <span>
          {{'deviceConnectionFailed' | translate}}
        </span>
      }
    </div>
  }

  @if (isWaiting || (isUser && !inCall)) {
    <div class="video_message">
      <div>
        <div>
          {{ isUser ? ('waitingForTechnician' | translate) : ('callWillStart' | translate) }}
        </div>
        <br>
          <small>{{ isUser ? ('micCameraReminder' | translate) : ('callWaitingInfoMessage' | translate) }}</small>
          <br>
            <br>
              <app-load [isLight]="true" class="text--xxs">
              </app-load>
            </div>
          </div>
        } @else {
          @if (isEnding) {
            <div class="video_message">
              <div>
                <div>
                  {{ 'callEnded' | translate }}
                </div>
                <app-load [isLight]="true" class="text--xxs">
                </app-load>
              </div>
            </div>
          }
        }


        <div
          id="video_renderer"
          class="video_renderer"
    [ngClass]="{
      'video_renderer--minimized': !!minimized, 
      'video_renderer--full': !!full
    }">
          @if (isControlsShown()) {
            <div class="video_controls">
              @if (!isMuted) {
                <div
                  (click)="mute.emit()"
                  matTooltip="{{ 'muteMicrophone' | translate | titlecase }}">
                  <i class="fas fa-microphone-slash"></i>
                </div>
              }
              @if (isMuted) {
                <div
                  (click)="unmute.emit()"
                  matTooltip="{{ 'unmuteMicrophone' | translate | titlecase }}">
                  <i class="fas fa-microphone-slash red"></i>
                </div>
              }
              @if (!isVideo) {
                <div
                  (click)="startVideo.emit()"
                  matTooltip="{{ 'showVideo' | translate | titlecase }}">
                  <i class="fas fa-video-slash red"></i>
                </div>
              }
              @if (isVideo) {
                <div
                  (click)="stopVideo.emit()"
                  matTooltip="{{ 'hideVideo' | translate | titlecase }}">
                  <i class="fas fa-video-slash"></i>
                </div>
              }
              <!-- hide screen share for now -->
              @if (!isSharing && false) {
                <div
                  (click)="startSharing.emit()"
                  matTooltip="{{ 'shareScreen' | translate | titlecase }}">
                  <i class="fas fa-desktop"></i>
                </div>
              }
              @if (isSharing && false) {
                <div
                  (click)="stopSharing.emit()"
                  matTooltip="{{ 'stopSharing' | translate | titlecase }}">
                  <i class="fas fa-desktop red"></i>
                </div>
              }
              <div (click)="endCall.emit()" matTooltip="{{ 'endCall' | translate | titlecase }}">
                <i class="fas fa-phone red"></i>
              </div>
            </div>
          }
        </div>

      </div>


